const API_URL = process.env.REACT_APP_BACKEND_URL;

export async function streamAdvisor(path, body, { onSession, onDelta }) {
  const res = await fetch(`${API_URL}/api/advisor/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `Request failed (${res.status})`);
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = '';
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const events = buf.split('\n\n');
    buf = events.pop();
    for (const ev of events) {
      const line = ev.split('\n').find((l) => l.startsWith('data: '));
      if (!line) continue;
      const msg = JSON.parse(line.slice(6));
      if (msg.error) throw new Error(msg.error);
      if (msg.session_id) onSession?.(msg.session_id);
      if (msg.delta) onDelta(msg.delta);
    }
  }
}
